/**
 * 人員登入狀態
 */
export enum LoginStateType {

    /** 0, 成功 */
    SUCCESS = 'SUCCESS',

    /** 1, 未知錯誤 */
    GENERAL_ERROR = 'GENERAL_ERROR',

    /**
     * 2, 登入帳號不存在=中大, 登入帳號不存在=中大): P007查無使用者或EP007.STATUS=USERSTATUS_CANCELLED
     */
    USER_NOT_FOUND = 'USER_NOT_FOUND',

    /** 3, 登入帳號停止使用, EP007.STATUS=USERSTATUS_SUSPENDED */
    USER_SUSPENDED = 'USER_SUSPENDED',

    /** 301, 登入帳號停止使用=中小型UUID錯誤達上限，且未換日不允許登入) */
    USER_SUSPENDED_NEW = 'USER_SUSPENDED_NEW',

    /** 302, 登入User暫停使用, User.Status=2 */
    USER_SUSPENDED_EP007 = 'USER_SUSPENDED_EP007',

    /** 4, 登入帳號已經鎖定, UserLoginStatus.STATUS_LOCKED */
    USER_LOCKED = 'USER_LOCKED',

    /** 5, 登入密碼錯誤=單純密碼錯誤，累加錯誤次數) */
    PIN_INCORRECT = 'PIN_INCORRECT',

    /** 6, 登入密碼已經過期=上次修改密碼時間至今已經超過365天，需強制修改密碼) */
    PIN_EXPIRED = 'PIN_EXPIRED',

    /** 7, 密碼錯誤次數達系統限制，已經鎖定, UserLoginStatus.STATUS_LOCKED */
    PIN_LOCKED = 'PIN_LOCKED',

    /** 8, 首次登入=建檔後首次登入，需強制修改UUID) */
    FIRST_LOGIN = 'FIRST_LOGIN',

    /** 9, 強制密碼重設=密碼重設後首次登入，需強制修改密碼) */
    FORCE_CHGPWD = 'FORCE_CHGPWD',

    /** 10, 已經登入=試圖重複登入, UserLoginStatus.STATUS_LOGIN */
    ALREADY_LOGIN = 'ALREADY_LOGIN',

    /** 11, 公司不存在, EP003無資料、或EP003.STATUS=STATUS_CANCELLED */
    CMP_NOT_FOUND = 'CMP_NOT_FOUND',

    /** 12, 公司停止使用, EP003.STATUS=STATUS_SUSPENDED */
    CMP_SUSPENDED = 'CMP_SUSPENDED',

    /** 13, 公司存在但登入帳號錯誤=中小, EP007查無使用者或EP007.STATUS=USERSTATUS_CANCELLED */
    UUID_INCORRECT = 'UUID_INCORRECT',

    /** 14, 已超過密碼單登入有效期限 */
    PIN_OVERDUE = 'PIN_OVERDUE',

    /** 15, UUID不合邏輯 */
    ILLEGAL_UUID = 'ILLEGAL_UUID',

    /** 16, 無Demo權限 */
    DEMO_DISABLED = 'DEMO_DISABLED',

    /** 17, 密碼不合邏輯 */
    ILLEGAL_PWD = 'ILLEGAL_PWD',

    /** 18, 使用者狀態有誤 */
    USER_STATUS_INCORRECT = 'USER_STATUS_INCORRECT',

    /** 19, 使用者尚未設定密碼 */
    USER_NO_PWD = 'USER_NO_PWD',

    /** 20, 登入IP非限定可登入IP */
    NOT_ALLOW_IP = 'NOT_ALLOW_IP',

    /** 21, 登入時間非限定可登入時間 */
    NOT_ALLOW_TIME = 'NOT_ALLOW_TIME',

    /** 22, 未申請使用本行企業行動網 */
    MOBILE_NOT_ALLOW_FOR_COMPANY = 'MOBILE_NOT_ALLOW_FOR_COMPANY',

    /** 23, 使用者未被授權使用企業行動網 */
    MOBILE_NOT_ALLOW_FOR_USER = 'MOBILE_NOT_ALLOW_FOR_USER',

    /** 24, 使用者已綁定行動裝置數量超出限制 */
    MOBILE_DEVICE_COUNT_LIMIT_FOR_USER = 'MOBILE_DEVICE_COUNT_LIMIT_FOR_USER',

    /** 25, 行動裝置已被其他使用者綁定 */
    MOBILE_DEVICE_ASSIGNED_FOR_OTHER_USER = 'MOBILE_DEVICE_ASSIGNED_FOR_OTHER_USER',

    /** 26, 行動裝置已自動綁定 */
    MOBILE_DEVICE_ASSIGNED_FOR_USER = 'MOBILE_DEVICE_ASSIGNED_FOR_USER',

    /** 27, 密碼驗證失敗=Servlet無法連結, 客戶端顯示:系統驗證不成功，請聯繫往來分行處理 */
    E2E_CONN_FAIL = 'E2E_CONN_FAIL',

    /** 28, 密碼驗證失敗=解密失敗, 客戶端顯示:系統驗證不成功，請聯繫往來分行處理 */
    E2E_VERIFY_FAIL = 'E2E_VERIFY_FAIL',

    /** 29, 密碼驗證失敗=超過允許時間範圍, 客戶端顯示:網頁連U線已過期，請重新登入 */
    E2E_VERIFY_TIMEOUT = 'E2E_VERIFY_TIMEOUT',

    /** 30, 密碼驗證失敗=安控系統時間格式錯誤, 客戶端顯示:系統驗證不成功，請聯繫往來分行處理 */
    E2E_SS_TIME_FORMAT_ERR = 'E2E_SS_TIME_FORMAT_ERR',

    /** 31, 密碼驗證失敗=企網銀主機時間格式錯誤, 客戶端顯示:系統驗證不成功，請聯繫往來分行處理 */
    E2E_CIB_TIME_FORMAT_ERR = 'E2E_CIB_TIME_FORMAT_ERR',

    /** 32, 登入資料不正確，請重新輸入 */
    E2E_INPUT_DATA_ERR = 'E2E_INPUT_DATA_ERR',

    /** 33, 密碼驗證失敗=加密密碼長度錯誤, 客戶端顯示:系統驗證不成功，請聯繫往來分行處理 */
    E2E_LENGTH_ERR = 'E2E_LENGTH_ERR',

    /** 34, 密碼驗證失敗=未知錯誤) */
    E2E_UNKNOWN_ERR = 'E2E_UNKNOWN_ERR',

    /** 35, 因貴公司已申請授權功能，請登入全球智匯網進行設定後即可使用。 */
    MOBILE_NEED_CHANGE_AUTHLEVEL = 'MOBILE_NEED_CHANGE_AUTHLEVEL',

    /** 36, 此連線已有所屬使用者. */
    SANE_SESSION_LOGIN = 'SANE_SESSION_LOGIN',

    /** UNKNOW. */
    UNKNOWN = 'UNKNOWN'
}
